import { Link } from "react-router-dom"
import { Icon } from "semantic-ui-react"

const { Table, ClippedContent } = require("dyl-components")

const HolidayScheduleSubRow = ({ routingRules }) => {
    return (
        <Table.CollapsibleRowContent indented nested colSpan="6">
            <Table.Cell colSpan="2">
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell><Icon name="fa-solid fa-route" /> Call Routing Rule</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {routingRules?.map((routingRule) => {
                            return <Table.Row>
                                <Table.Cell >
                                    <div className="HolidayScheduleTable__SubRow">
                                        <ClippedContent popupContent={routingRule?.label}> <Link to={`/settings/phone-management/routing/call-routing-rules?search=${routingRule?.label}&page=1`}>
                                            <Icon name="fa-solid fa-route" /> {routingRule?.label}
                                        </Link></ClippedContent>
                                    </div>
                                </Table.Cell>
                            </Table.Row>
                        })}
                    </Table.Body>
                </Table>
            </Table.Cell>
        </Table.CollapsibleRowContent>
    )
}

export default HolidayScheduleSubRow;